import React, { useEffect, useState } from "react";

import "./Report.css";
import "../../Components/Commons/Commons.css";

import SidebarMenu from "../../Components/Sidebar/Sidebar";
import AntDTable from "../../Components/AntDTable/AntDTable";
import BtnExcel from "../../Components/Commons/Buttons/BtnExcel";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";

import { DatePicker } from "antd";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getCensusOfDiseases } from "../../Components/Helpers/API/ReportsApi/ReportsApi";
import { getTodayDateISO } from "../../Helpers/Utils/Common";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

function CensusOfDiseases() {
  const navigateto = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [data, setData] = useState([]);
  const [totalDiagnosisCount, setTotalDiagnosisCount] = useState("");
  const xlsxHeaders = ["Total Cases", "Disease"];
  const [filterConfig, setFilterConfig] = useState({
    date_from: "",
    date_to: "",
  })

  //Function for custom footer in table
  const customFooter = () => (
    <div style={{ textAlign: "center" }}>
      Total: {totalDiagnosisCount} cases
    </div>
  );

  //Function for adding action button in the table
  function ActionBtn(row) {
    return (
      <Row className="center">
        <Col>
          <BtnSave
            id={"green-btn"}
            label={"View"}
            size={"sm"}
            onClick={(e) =>
              navigateto(`/census-of-diseases/view/${encodeURIComponent(row.row.diagnosis)}`)
            }
          />
        </Col>
      </Row>
    );
  }

  //Handler function for date range picker filter
  function handleDateFilterChange(dates){
    var [dateFrom, dateTo] = dates || [];
    setFilterConfig((prev) => ({
      ...prev,
      date_from: dateFrom ? dateFrom.format("YYYY-MM-DD") : "",
      date_to: dateTo ? dateTo.format("YYYY-MM-DD") : "",
    }));
  }

  //Function get for census of disease API
  async function fetchCensusOfDiseases() {
    setShowLoader(true);
    const res = await getCensusOfDiseases({
      date_from: filterConfig.date_from,
      date_to: filterConfig.date_to
    });

    if (res.data) {
      setTotalDiagnosisCount(res.data.total_diagnosis_count);
      setData(res.data.data);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    fetchCensusOfDiseases();
  }, [filterConfig]);

  return (
    <div className="App">
      <SidebarMenu active={"Reports"} active_sub={"Census of Diseases"} />
      <div className="col p-5 pt-4 scrollable-container">
        <div className="row pt-2 p-3">
          <div className="col font-big title-2 all-patient">
            Census of Disease
          </div>
          
          <div className="col-2 left patient-manager">
            <BtnExcel
              label={"Download Excel"}
              size={"sm"}
              excelData={data}
              xlsxHeaders={xlsxHeaders}
              fileName={`Census_of_diseases_as_of_${getTodayDateISO()}.xlsx`}
            />
          </div>
        </div>
        <Row>
          <Col>
            <div className="row justify-content-start">
              <div className=" pl-0 mb-3">
              <RangePicker
                placeholder={["Start Date", "End Date"]}
                className="w-full m-2"
                format="YYYY-MM-DD" 
                value={[
                  filterConfig.date_from ? dayjs(filterConfig.date_from) : null,
                  filterConfig.date_to ? dayjs(filterConfig.date_to) : null,
                ]}
                onChange={(dates) => {
                  handleDateFilterChange(dates)
                }}
                showTime={false}
                allowClear={true}
              />
              </div>
            </div>
          </Col>
        </Row>
        <div className="row justify-content-center">
          <div className="col-sm-12" id="antd-table-container">
            <AntDTable
              tableHeaders={["Disease", "Total Cases"]}
              headerSelector={["diagnosis", "diagnosis_count"]}
              tableData={data}
              loading={showLoader}
              customFooter={customFooter}
              withAction={true}
              ActionBtn={(row) => ActionBtn(row)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CensusOfDiseases;
